import React from 'react';
import { SlideLayout } from './SlideLayout';
import { motion } from 'framer-motion';
export function Slide1_Category() {
  return <SlideLayout className="text-center" data-id="element-38">
      <div className="flex flex-col items-center justify-center h-full space-y-8 sm:space-y-12" data-id="element-39">
        <div className="space-y-4 sm:space-y-6 max-w-4xl px-4" data-id="element-40">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-bold tracking-tight text-white leading-[1.1]" data-id="element-41">
            Your Growth Isn't Capped by Sales. <br data-id="element-42" />
            <span className="text-emerald-400" data-id="element-43">It's Capped by Recruiting.</span>
          </h1>
          <p className="text-lg sm:text-xl md:text-2xl text-slate-400 font-light" data-id="element-44">
            Every missed rep costs money, momentum, and morale.
          </p>
        </div>

        {/* Abstract Bottleneck Visual - Hidden on small mobile */}
        <div className="relative w-full max-w-2xl h-32 sm:h-48 flex items-center justify-center px-4" data-id="element-45">
          {/* Sales Capacity (Wide) */}
          <motion.div className="absolute left-0 h-20 sm:h-32 w-1/3 bg-slate-800/50 rounded-l-lg border border-slate-700 flex items-center justify-center" initial={{
          opacity: 0,
          x: -50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.3
        }} data-id="element-46">
            <span className="text-slate-400 font-medium tracking-widest uppercase text-xs sm:text-sm px-2 text-center" data-id="element-47">
              Sales Demand
            </span>
          </motion.div>

          {/* Recruiting Constraint (Narrow) */}
          <motion.div className="absolute left-1/3 w-1/3 h-8 sm:h-12 bg-emerald-500/20 border border-emerald-500/50 flex items-center justify-center z-10 backdrop-blur-sm" initial={{
          scaleY: 0
        }} animate={{
          scaleY: 1
        }} transition={{
          delay: 0.6,
          duration: 0.5
        }} data-id="element-48">
            <span className="text-emerald-400 font-bold tracking-widest uppercase text-[10px] sm:text-xs px-2 text-center" data-id="element-49">
              Recruiting Capacity
            </span>
          </motion.div>

          {/* Actual Growth (Restricted) */}
          <motion.div className="absolute right-0 h-8 sm:h-12 w-1/3 bg-slate-800/50 rounded-r-lg border border-slate-700 border-l-0 flex items-center justify-center" initial={{
          opacity: 0,
          x: 50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.9
        }} data-id="element-50">
            <span className="text-slate-500 font-medium tracking-widest uppercase text-xs sm:text-sm px-2 text-center" data-id="element-51">
              Actual Growth
            </span>
          </motion.div>

          {/* Connecting Lines */}
          <svg className="absolute inset-0 w-full h-full pointer-events-none" style={{
          zIndex: -1
        }} data-id="element-52">
            <motion.path d="M 33% 35% L 33% 45% L 66% 45% L 66% 35%" fill="none" stroke="currentColor" className="text-slate-700" strokeWidth="1" initial={{
            pathLength: 0
          }} animate={{
            pathLength: 1
          }} transition={{
            delay: 0.5,
            duration: 0.5
          }} data-id="element-53" />
            <motion.path d="M 33% 65% L 33% 55% L 66% 55% L 66% 65%" fill="none" stroke="currentColor" className="text-slate-700" strokeWidth="1" initial={{
            pathLength: 0
          }} animate={{
            pathLength: 1
          }} transition={{
            delay: 0.5,
            duration: 0.5
          }} data-id="element-54" />
          </svg>
        </div>
      </div>
    </SlideLayout>;
}